[
  {
    "code": "SA-11",
    "name": "Al Bahah"
  },
  {
    "code": "SA-08",
    "name": "Al Hudud ash Shamaliyah"
  },
  {
    "code": "SA-12",
    "name": "Al Jawf"
  },
  {
    "code": "SA-03",
    "name": "Al Madinah"
  },
  {
    "code": "SA-05",
    "name": "Al Qasim"
  },
  {
    "code": "SA-01",
    "name": "Ar Riyad"
  },
  {
    "code": "SA-04",
    "name": "Ash Sharqiyah"
  },
  {
    "code": "SA-06",
    "name": "Ha'il"
  },
  {
    "code": "SA-09",
    "name": "Jizan"
  },
  {
    "code": "SA-02",
    "name": "Makkah"
  },
  {
    "code": "SA-10",
    "name": "Najran"
  },
  {
    "code": "SA-07",
    "name": "Tabuk"
  },
  {
    "code": "SA-14",
    "name": "‘Asir"
  }
]